import React from 'react';
import { compose } from 'recompose';
import { Page, withForm } from 'components/common';
import { FormGroup, required, SaveButton } from 'components/common/Forms';
import { LocalForm, Control, Errors, actions } from 'react-redux-form';
import { NotificationManager } from 'react-notifications';
import { get } from 'lodash';
import { refreshToken } from '../../services/Auth';

const passwordsMatch = ({ password, confirm_new_password }) => {
  if (!(password && confirm_new_password)) return true;
  return password === confirm_new_password;
};

const HelpText = props => (
  <span className="form-text small text-danger" {...props} />
);

export const Profile = ({
  item,
  onSubmit,
  form,
  setDispatch,
  onUpdate,
  onChange,
  dispatch,
}) => (
  <Page title="Change My Password">
    <LocalForm
      initialState={item}
      onSubmit={onSubmit}
      getDispatch={setDispatch}
      onUpdate={onUpdate}
      onChange={onChange}
      validators={{
        '': { passwordsMatch },
      }}
    >
      <FormGroup label="Current Password *" model=".current_password">
        <Control.text
          updateOn="blur"
          type="password"
          changeAction={(model, value) => {
            dispatch(actions.change(model, value));
            dispatch(
              actions.setValidity(model, {
                serverValidation: true,
              })
            );
          }}
          model=".current_password"
          validators={{ required }}
          autocomplete="current-password"
        />
        <Errors
          model=".current_password"
          messages={{ serverValidation: 'Current Password is not correct' }}
          component={HelpText}
        />
      </FormGroup>
      <hr />
      <FormGroup label="New Password *" model=".password">
        <Control.text
          updateOn="blur"
          changeAction={(model, value) => {
            dispatch(actions.change(model, value));
            dispatch(
              actions.setValidity(model, {
                serverValidation: true,
              })
            );
          }}
          type="password"
          model=".password"
          validators={{ required }}
          autocomplete="new-password"
        />
        <Errors
          model=".password"
          messages={{
            serverValidation:
              'Password must be at least 8 characters and be a mix of letters and numbers',
          }}
          component={HelpText}
        />
      </FormGroup>
      <FormGroup label="Confirm New Password *" model=".confirm_new_password">
        <Control.text
          updateOn="blur"
          type="password"
          model=".confirm_new_password"
          validators={{ required }}
          autocomplete="new-password"
        />
        <Errors
          model="local"
          messages={{ passwordsMatch: 'Passwords do not match' }}
          component={HelpText}
        />
      </FormGroup>
      <div className="d-flex justify-content-end">
        <SaveButton form={form}>Update</SaveButton>
      </div>
    </LocalForm>
  </Page>
);

export const enhance = compose(
  withForm({
    onSubmit: ({
      client,
      item: { password, current_password },
      dispatch,
    }) => () => {
      return client
        .post('/profile', {
          current_password,
          password,
        })
        .tap(() => {
          NotificationManager.success('Password updated successfully');
          dispatch(actions.reset('local'));
          refreshToken();
        })
        .catch(err => {
          const code = get(err, 'response.data.code');

          if (code === 'CurrentPasswordInvalid') {
            dispatch(
              actions.setValidity('local.current_password', {
                serverValidation: false,
              })
            );
          } else if (code === 'PasswordFailsValidation') {
            dispatch(
              actions.setValidity('local.password', {
                serverValidation: false,
              })
            );
          } else {
            throw err;
          }
        });
    },
  })
);

export default enhance(Profile);



// WEBPACK FOOTER //
// ./src/pages/Profile/index.jsx